module.exports = __webpack_public_path__ + "img/1-3.6adb4792.svg";